import { observer } from 'mobx-react';
import AgentView from '../Home/components/AgentView';

const Profiler = observer(() => {
  return <AgentView isFromInvestorView />;
});

export default Profiler;
